import { useApp }  from "../context/AppContext";
import { useCart } from "../context/CartContext";
import CategoryNav  from "./CategoryNav";

export default function Header() {
  const { navigate, setSearch, search } = useApp();
  const { totalItems } = useCart();

  const handleSearch = (e) => {
    setSearch(e.target.value);
    navigate("products");
  };

  return (
    <header className="header">
      <div className="header-inner">

        {/* Logo */}
        <div className="brand" onClick={() => navigate("home")}>
          <img src="/private_logo.png" alt="Private Convenience" className="brand-logo" />
          <div>
            <div className="brand-name">Private Convenience</div>
            <div className="brand-sub">London · Ontario</div>
          </div>
        </div>

        {/* Desktop search */}
        <div className="header-search">
          <input
            placeholder="Search chips, drinks, candies…"
            value={search}
            onChange={handleSearch}
          />
          <button onClick={() => navigate("products")}>🔍</button>
        </div>

        {/* Action buttons */}
        <div className="header-actions">
          <button className="header-btn" onClick={() => navigate("about")}>
            <span className="header-btn-icon">ℹ️</span>
            <span className="header-btn-label">About</span>
          </button>
          <button className="header-btn" onClick={() => navigate("contact")}>
            <span className="header-btn-icon">✉️</span>
            <span className="header-btn-label">Contact</span>
          </button>

          {/* Cart with badge */}
          <button className="header-btn cart-header-btn" onClick={() => navigate("cart")}>
            <span className="cart-icon-wrap">
              <span className="header-btn-icon">🛒</span>
              {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
            </span>
            <span className="header-btn-label">Cart</span>
          </button>

          {/* Hamburger */}
          <button
            className="hamburger-btn"
            onClick={() => window.dispatchEvent(new CustomEvent("open-mobile-menu"))}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* Mobile search */}
      <div className="mobile-search">
        <input placeholder="Search products…" value={search} onChange={handleSearch} />
      </div>

      <CategoryNav />
    </header>
  );
}
